<template>
  <div class="merge-detail" :loading="loading">
    <div v-if="commits.length === 0 && !loading" class="empty-container container-card">
      <a-empty description="暂时还没有代码提交哦~" />
    </div>
    <a-spin :spinning="loading" tip="正在获取变更信息...">
      <div class="container">
        <div class="left-container">
          <div class="commit-list">
            <div v-for="commit in commits" :key="commit.commit_id" class="commit-card container-card" :class="{ active: currentCommitId === commit.commit_id }" @click="selectCommit(commit)">
              <div class="commit-header">
                <div class="commit-title">
                  <span class="commit-message" :class="{ expanded: currentCommitId === commit.commit_id }">
                    <span class="commit-author">{{ commit.author_name }}@</span>{{ commit.commit_message }}
                  </span>
                </div>
              </div>
              <div v-show="currentCommitId === commit.commit_id" class="commit-content">
                <a-spin :spinning="loading">
                  <div class="file-tree">
                    <el-tree v-show="fileTree.length > 0" :data="fileTree" :default-expand-all="true" highlight-current>
                      <template #default="{ node, data }">
                        <span class="custom-tree-node father">
                          <span class="node-icon">
                            <svg class="icon" aria-hidden="true">
                              <use :xlink:href="getIconClass(data.type)" />
                            </svg>
                          </span>
                          <a-tooltip placement="right" :title="node.label">
                            <span class="node-title" :style="getTitleClass(node, data)" @click="codeDiff(data)">
                              {{ node.label }}
                            </span>
                          </a-tooltip>
                          <span class="create-line" @click="codeDiff(data)">{{ data.type === 'folder' ? '' : '+' }}{{ data.create_line }}</span>
                          <span class="delete-line" @click="codeDiff(data)">{{ data.type === 'folder' ? '' : '-' }}{{ data.delete_line }}</span>
                        </span>
                      </template>
                    </el-tree>
                  </div>
                </a-spin>
              </div>
              <div class="commit-meta">
                <a target="_blank" :href="`${commit.http_url.replace('.git', '')}/-/commit/${commit.commit_id}`"> {{ commit.commit_id.slice(0, 8) }}@{{ commit.git_name }} </a>
                <span class="commit-time">{{ commit.committed_time }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right-container">
          <div class="diff-container">
            <a-radio-group v-if="Object.keys(diff).length > 0" v-model="diffType" size="small">
              <a-radio-button value="line-by-line">行</a-radio-button>
              <a-radio-button value="side-by-side">列</a-radio-button>
            </a-radio-group>
            <git-diff-code v-if="Object.keys(diff).length > 0" :value="diff.content" :path="diff.path" :output-format="diffType" />
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { queryTaskCode } from '@/api/project/task';

import Accurate from '@/api/project/accurate';
import GitDiffCode from '@/components/GitDiffCode';

export default {
  components: { GitDiffCode },
  props: {
    sourceId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      diffType: 'side-by-side',
      content: null,
      loading: true,
      commits: [],
      current_commit: {},
      currentCommitId: null,
      fileTree: [],
      diff: {}
    };
  },

  computed: {
    tabName() {
      return commit => {
        return `${commit.commit_id.slice(0, 8)}@${commit.commit_message.slice(0, 15)}`;
      };
    }
  },

  created() {
    this.getTaskCode();
  },

  methods: {
    getTaskCode(commit_id = null) {
      this.loading = true;
      this.fileTree = [];
      queryTaskCode({ task_id: this.sourceId, commit_id: commit_id })
        .then(res => {
          this.loading = false;
          this.commits = res.data.commits;
          this.current_commit = res.data.current_commit;
          this.currentCommitId = this.current_commit.commit_id;
          this.fileTree = Accurate.getTreeDTO(
            this.current_commit.files.map(item => {
              return {
                path: item.new_path,
                content: item.content,
                create_line: item.additions,
                delete_line: item.deletions
              };
            })
          );
          const findFirstFile = tree => {
            if (!tree || tree.length === 0) return null;
            const firstNode = tree[0];
            if (firstNode.type === 'folder' && firstNode.children) {
              return findFirstFile(firstNode.children);
            }
            return firstNode;
          };
          const firstFile = findFirstFile(this.fileTree);
          if (firstFile) {
            this.codeDiff(firstFile);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    selectCommit(commit) {
      if (this.currentCommitId === commit.commit_id) {
        this.currentCommitId = null;
      } else {
        this.currentCommitId = commit.commit_id;
        this.getTaskCode(commit.commit_id);
      }
    },

    getIconClass(val) {
      const fileTypeList = ['folder', 'go', 'vue', 'png', 'css', 'html', 'js'];
      if (fileTypeList.indexOf(val) > -1) {
        return '#icon-' + val;
      } else {
        return '#icon-unknown.svg';
      }
    },
    getTitleClass(node, data) {
      if (!data.status) {
        return;
      }
      switch (data.status) {
        case 1:
          return 'color:#1E90FF';
        case 2:
          return 'color:#13CD54';
        case 3:
          return 'color:#909399;text-decoration:line-through';
        case 4:
          return 'color:#FF4500';
      }
    },
    codeDiff(data) {
      this.diff = { ...data };
    }
  }
};
</script>

<style lang="less" scoped>
.merge-detail {
  min-height: 400px;
}
.container {
  display: flex;
  min-height: 400px;
  gap: 16px;

  .container-card {
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    padding: 12px;
  }

  .left-container {
    width: 360px;
    flex-shrink: 0;
    overflow: auto;

    .commit-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .commit-card {
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        border-color: #1890ff;
      }

      &.active {
        border-color: #1890ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      }

      .commit-header {
        .commit-title {
          margin-bottom: 8px;
          display: flex;
          align-items: flex-start;

          .commit-author {
            color: #1890ff;
            font-weight: 500;
            flex-shrink: 0;
          }

          .commit-message {
            color: #262626;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            transition: all 0.3s;

            &.expanded {
              -webkit-line-clamp: unset;
              white-space: pre-wrap;
              word-break: break-all;
            }
          }
        }
      }

      .commit-meta {
        display: flex;
        justify-content: space-between;
        color: #8c8c8c;
        font-size: 12px;
        font-weight: normal;

        a {
          color: #8c8c8c;
          text-decoration: none;

          &:hover {
            color: #1890ff;
          }
        }
      }

      .commit-content {
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid #f0f0f0;

        .file-tree {
          min-height: 60px;
          overflow: auto;
        }
      }
    }
  }

  .right-container {
    flex: 1;
    overflow: hidden;
    background: #fff;
  }

  .custom-tree-node {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    width: 100%;
  }

  .father .child {
    display: none;
  }

  .father:hover .child {
    display: block;
  }

  .icon {
    width: 1.2em;
    height: 1.2em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }

  .node-title {
    width: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1 auto;
    padding: 0 5px;
    overflow: hidden;
    font-weight: 500;
  }

  .create-line {
    color: #217645;
  }

  .delete-line {
    margin-left: 3px;
    color: #dd2b0e;
  }
}

.diff-container {
  height: 100%;
  overflow: auto;

  ::v-deep .d2h-file-wrapper {
    margin-bottom: 0 !important;
  }
}

.empty-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}
</style>
